import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import dissolve_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/merge_faces.svg';
import { img } from '@phi/components';
import { uid_merge_selected_faces } from '@frontend/ui_display';
import DissolveTooltip from './DissolveTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const DissolveIcon = dissolve_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Dissolve';
        },

        disabled() {
            return !this.state.loaded
                || this.state.selected_faces_count <= 1;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                uid_merge_selected_faces();
        },
    },

    render() {
        return h(BarButton, {
            id: 'merge-faces-button',
            wrapperId: 'merge-faces-wrapper',
            active: false,
            selected: this.state.tut_stage === 6,
            disabled: this.disabled,
            onClick: this.onClick,
            tippy: 'left',
            help: 'merge_faces',
        }, {
            label: () => 'Dissolve',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(dissolve_svg, this.alt),
            tooltip: DissolveTooltip,
        });
    },
});
